<template>
  <router-view></router-view>
</template>

<script>
import serviceWorker from "./mixins/service-worker";
export default {
  name: "App",
  mixins: [serviceWorker],
  mounted() {
    // Change the backound image depending on the APP_ENV
    let imageUrl = "/img/107672_adjusted.jpg";
    if (window.app_env !== "production") {
      imageUrl = "/img/huntsman_dev_background.png";
    }
    document.documentElement.style.setProperty(
      "--app-bg-url",
      `url("${imageUrl}")`
    );
  }
};
</script>
<style>
/* apply a background image to the page, and make the
   content containers transparent*/
html {
  background: var(--app-bg-url) no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.bgImage {
  background: transparent !important;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.5s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate(-2em, 0);
}
</style>
